export class DashboardView {
parentBnfId: string;
        caseType: string;
        requestType: string;
        applicantType: string;
    }
